import React, {useEffect} from 'react';
import {useSidebar} from '@src/components/shadcn/sidebar';
import {Link} from 'react-router-dom';
import EzManageNavLinkLogo from '@src/icons/EzManageNavLinkLogo';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBars, faXmarkLarge} from '@fortawesome/pro-light-svg-icons';
import {NavItem} from './types';

const NavHeader = ({homeNavItem}: {homeNavItem: NavItem}) => {
  const {isMobile, openMobile, setOpenMobile} = useSidebar();
  useEffect(() => {
    if (isMobile) {
      setOpenMobile(false);
    }
  }, [isMobile, setOpenMobile]);

  const toggleMobileNavbar = () => {
    setOpenMobile(!openMobile);
  };
  return (
    <div className="flex justify-between items-center inset-0 h-12 px-5 w-full md:w-[--sidebar-width]">
      <Link className="block" to={homeNavItem.to}>
        <EzManageNavLinkLogo />
      </Link>
      {isMobile && (
        <FontAwesomeIcon
          onClick={toggleMobileNavbar}
          className="cursor-pointer"
          icon={openMobile ? faXmarkLarge : faBars}
        />
      )}
    </div>
  );
};

export default NavHeader;
